import React from "react";
import pageNotFound from "../Assets/PageNotFound/pageNotFound.svg";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex justify-evenly items-center h-screen w-screen">
      <div className="flex flex-col justify-center gap-2 items-center  h-[50vh] text-blackPrimaryText dark:text-darkModeBlackPrimaryText">
        <p className="font-semibold text-[44px]">Page not found</p>
        <p className="text-[14px]">
          Sorry, the page you are looking for could not be found.
        </p>
        <Link to={"/"}>
          <button className="px-4 py-2 bg-primaryBgColor dark:bg-darkModePrimaryBgColor rounded-md font-semibold my-4">
            Return Home
          </button>
        </Link>
      </div>
      <div>
        <img alt="Page not found illustration" src={pageNotFound} />
      </div>
    </div>
  );
};

export default NotFound;
